import ShaderBase from "./_shaderBase.js";
import { fieldUniforms } from "./shader-chunks.js";
export default class Grid extends ShaderBase {}
Grid.prototype.defaultOptions = {
  color: 0x3bdada,
  color2: 0x496bfd,
  backgroundColor: 0x060e1a,
};
Grid.prototype.fragmentShader =
  fieldUniforms +
  `
void main(){vec2 uv=(gl_FragCoord.xy-.5*iResolution)/iResolution.y;vec2 m=(iMouse-.5*iResolution)/iResolution.y;float d=length(uv-m);vec2 p=uv*(1.+.13*exp(-d*4.)*sin(d*13.-iTime*1.2)*intensity);p.y+=iTime*.008;vec2 g=abs(fract(p*18.+.5)-.5);vec2 aa=fwidth(p*18.);float line=1.-smoothstep(.015,.015+max(aa.x,aa.y),min(g.x,g.y));float glow=exp(-d*3.);vec3 c=backgroundColor+mix(color2,color,glow)*line*(.12+.6*glow)*intensity;c+=color*exp(-d*d*40.)*.12*intensity;gl_FragColor=vec4(c,1.);}`;
